import * as React from "react";
import { useLocation } from "react-router";


export default function withLocation(Component) {
  return props => <Component location={useLocation()} {...props} />;
}

